export default __webpack_public_path__ + "static/media/plain-sticker-C.f1ef2250.png";